/**
 * @enum
 * This is case sensitive. Please make sure the values are the same as the ones in the database.
 */
const ChecklistTypes = Object.freeze({
	Patrol: 'Patrol',
	Incident: 'Incident',
});

export default ChecklistTypes;
